import classnames from 'classnames';
import ChevronIcon from 'components/icons/ChevronIcon';
import React from 'react';

import CarouselButton, { CarouselButtonProps } from './CarouselButton';

const CSS = require('./SideButtons.module.scss');

type NextButtonProps = {
  disabled?: boolean;
  onClick: (e: any) => void;
  isInverted?: boolean;
} & Omit<CarouselButtonProps, 'children'>;

function NextButton({
  disabled,
  onClick,
  isInverted,
  ...rest
}: NextButtonProps) {
  return (
    <CarouselButton
      onClick={onClick}
      disabled={disabled}
      aria-label="Next"
      isInverted={isInverted}
      {...rest}
    >
      <ChevronIcon
        width={9}
        height={15}
        className={classnames(CSS.NextChevronIcon, {
          [CSS.DisabledIcon]: disabled,
          [CSS.InvertedIcon]: isInverted,
        })}
      />
    </CarouselButton>
  );
}

export default NextButton;
